import React from "react"

const Following = () => {
    return (
        <div></div>
    )
}

export default Following